import React, { useContext } from 'react';
import DOMPurify from 'dompurify';
import BookerContext from '../../context/bookerContext';
import store from '../../store/bookerStore';
import fieldParams from '../../const/fieldParams';
import '../../assets/styles/popup.sass';

const Popup = ({ popup, togglePopup, message }) => {
  const { isOpen, key, buttons } = popup;
  const { popupText, popupTitle } = fieldParams[key] || {};
  const context = useContext(BookerContext);
  const { state: { error, accountCreation, accountCreation: { done, flow, isShown } = {}, isMeteredFare } = {} } =
    context;

  let text;
  if (popupText) text = popupText;
  else if (error === 'global') text = message;
  if (key === 'code' && typeof popupText === 'function') {
    const { phone: { requestNumber = 0 } = {} } = store.getState();
    text = popupText(requestNumber > 4);
  }
  if (key === 'fare' && typeof popupText === 'function') {
    const { state: { fare: { isExpired = false } = {} } = {} } = context;
    text =
      isMeteredFare && !isExpired
        ? `<span>About Metered Rates</span> \nFare estimates are provided as a courtesy by Curb and may not reflect applicable taxes, tolls, extras, or flat rates (e.g. airport rates).`
        : popupText(isExpired);
  }
  if (key === 'removePayment' && typeof popupText === 'function') {
    const card = buttons?.find(b => !!b.card)?.card;
    text = popupText(card);
  }

  const closeHandler = () => {
    if (typeof togglePopup !== 'function') return;

    togglePopup(false, key);
  };

  if ((accountCreation && key === 'signUpOfferPre') || ((done || flow || isShown) && key === 'signUpOfferPost'))
    return <></>;
  if (!isOpen) return <></>;
  if ((error === 'global' || key === 'error') && !message) return <></>;
  return (
    <div className={`popup-overlay ${key}`}>
      <div className="popup-container">
        {popupTitle && <div className="popup-title">{popupTitle}</div>}
        <div className="popup-content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
        {typeof buttons !== 'boolean' && (
          <div className="popup-action">
            {buttons?.map((item, i) => (
              <button
                key={i}
                className={'btn btn-popup' + (item.isSecondary ? ' btn-secondary' : ' btn-default')}
                onClick={item.clickHandler ?? closeHandler}
              >
                {item.textBtn}
              </button>
            ))}

            {!buttons && (
              <button className="btn btn-popup btn-default" onClick={closeHandler}>
                Ok
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Popup;
